import { Multimedia } from "src/app/common/models/multimedia/multimedia";
import { PlaceBase } from "src/app/common/models/place/place-base";

export class PlaceComponentModel extends PlaceBase {
    multimedias : Multimedia[];

}
